import { useQuery } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import { adminUserKeys } from './queryKeys';

export const useAdminUserDetail = (adminUserId: string | null) => {
  return useQuery({
    queryKey: adminUserKeys.detail(adminUserId!),
    queryFn: async () => {
      const response = await adminUsersApi.getUser(adminUserId!);
      return response.data;
    },
    enabled: adminUserId !== null,
    // Refetch detail every time the modal opens so the data is never stale.
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
